export class LoanOfficerRegionReference {
    public id: string;
    public timeStamp: Date;
    public loanNumber: string;
    public lastCompletedMilestone: string;
    public roleEffected: string;
    public renderedErrorMessage: string;

    public timeStampDisplay: string;
}

export class Region {
    public id: string;
    public name: string;
    public group: string;
    public tooltip: string;
}

export class PropertyState {
    public id: string;
    public subjectpropertystatename: string;
    public regionid: string;
    public tooltip: string;
}

export class Subregion {
    public id: string;
    public name: string;
    public group: string;
}

export class SubregionAssignment {
    public id: string;
    public city: string;
    public subregionId: string;
}

export class AddSubregionAssignment {
    public city: string;
    public subregionId: string;
}




// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/loan-officer-region-reference/loanofficerregionreference.model.ts